import { useState } from 'react';
import { Box, TextField, Link, Alert } from '@mui/material';
import CustomButton from './CustomButton';

const PasswordResetForm = ({ onSubmit, onBackToLogin, error, successMessage }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState('');

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError('');
    
    if (!email.trim()) {
      setEmailError('Email address is required');
      return;
    }
    
    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    
    setLoading(true);
    
    try {
      await onSubmit(email);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      
      {successMessage && (
        <Alert severity="success" sx={{ mb: 3 }}>
          {successMessage}
        </Alert>
      )}
      
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          id="reset-email-input"
          label="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email address"
          fullWidth
          variant="standard"
          InputProps={{ disableUnderline: false }}
          inputProps={{
            'aria-label': 'Email address for password reset',
            'aria-describedby': 'email-helper-text',
          }}
          error={!!emailError}
          helperText={emailError}
          sx={{ 
            mb: 4,
            '& .MuiInputBase-input': {
              fontSize: '1.1rem',
              // Mobile responsive input
              '@media (max-width: 600px)': {
                fontSize: '1rem',
              },
            },
          }}
        />
        
        <CustomButton
          type="submit"
          text={loading ? "Sending..." : "Send Reset Link"}
          color="#121212"
          hoverColor="linear-gradient(90deg, #d5d5d5 0%, #ffffff 100%)"
          textColor="white"
          hoverTextColor="#000"
          width="100%"
          fullWidth
          disabled={loading}
        />
        
        <Link
          component="button"
          type="button"
          underline="always"
          onClick={onBackToLogin}
          sx={{ 
            mt: 4, 
            display: 'block', 
            color: '#555', 
            fontSize: '1rem', 
            textAlign: 'center',
            width: '100%',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            // Mobile responsive link
            '@media (max-width: 600px)': {
              fontSize: '0.9rem',
              mt: 3,
            },
          }}
        >
          Back to login
        </Link>
      </Box>
    </Box>
  );
};

export default PasswordResetForm; 